/* eslint-disable @typescript-eslint/no-empty-function */
export function noop() {}
